 
import { createSlice } from '@reduxjs/toolkit';
import {
  ActivateState,
  ActivateStateSetErrorsActions,
  ClinicalTrialActivateActions,
} from './activate.types';
import { createSliceHook, makeActionCreator, createSelector } from '../helpers';

const initialState: ActivateState = {
  errors: {
    generalInfo: [],
    visits: [],
    imagingLabels: [],
    forms: [],
  },
  loading: false,
};

const { act, actReq, actResolve } = makeActionCreator<ActivateState>();

export const activateClinicalTrialSlice = createSlice({
  name: 'activateClinicalTrial',
  initialState,
  reducers: {
    setErrors: act<ActivateStateSetErrorsActions['payload']>(
      ({ name, errors }, state) => {
        return {
          ...state,
          errors: {
            ...state.errors,
            [name]: errors,
          },
        };
      }
    ),
    clearErrors: () => initialState,
    activateClinicalTrial:
      actReq<ClinicalTrialActivateActions['payload']>('loading'),
    activateClinicalTrialSuccess: actResolve<null>(null, 'loading'),
    activateClinicalTrialFailure: actResolve<null>(null, 'loading'),
  },
});

export const { clearErrors, setErrors } = activateClinicalTrialSlice.actions;

export const actions = {
  ...activateClinicalTrialSlice.actions,
};

export const useActivateClinicalTrialSlice = createSliceHook(
  activateClinicalTrialSlice.name,
  actions
);

export const selectActivateState = createSelector('activateClinicalTrial');
